import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { tocActions } from "@/store/actions/toc.actions";

// Use this hook to store the initial data from SSR to redux.
export const useStoreSSRInitialDataTOC = (itemOrItems) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const store = (toc) => {
      if (toc?.[0]) {
        const bookId = toc[0].id.split(".")[0];
        dispatch(tocActions.setItem(bookId, toc));
      }
    };
    if (Array.isArray(itemOrItems?.[0])) {
      itemOrItems.forEach(store);
    } else {
      store(itemOrItems);
    }
  }, []);
};